export default __webpack_public_path__ + "static/media/previewImg.74aefa8d.svg";